import { Link } from "react-router-dom";

type RecoveryAction = {
  href: string;
  label: string;
};

type ArtifactRouteRecoveryProps = {
  eyebrow: string;
  title: string;
  message: string;
  primaryAction: RecoveryAction;
  secondaryAction?: RecoveryAction;
};

export function ArtifactRouteRecovery({
  eyebrow,
  title,
  message,
  primaryAction,
  secondaryAction,
}: ArtifactRouteRecoveryProps) {
  return (
    <div className="mx-auto max-w-xl rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        {eyebrow}
      </p>
      <h2 className="mt-3 text-xl font-semibold text-slate-900">{title}</h2>
      <p className="mt-3 text-sm leading-6 text-slate-600">{message}</p>
      <div className="mt-5 flex flex-wrap gap-3">
        <Link
          to={primaryAction.href}
          className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
        >
          {primaryAction.label}
        </Link>
        {secondaryAction ? (
          <Link
            to={secondaryAction.href}
            className="rounded-lg border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:border-slate-400 hover:text-slate-900"
          >
            {secondaryAction.label}
          </Link>
        ) : null}
      </div>
    </div>
  );
}
